// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"621":"d9ed8fa1","821":"85dd48fb"}[chunkId] + ".css";
};